import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Card, DoughnutChart } from "ui-kit-ck-consultant";
import moment from "moment";

import {
  getCurrencyValue,
  getPercentageValue,
  getValue,
} from "../../../utils/general";

import AuthContext from "../../../context/AuthContext";

const formatDay = (date) => moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");

const formatRange = (start, end) =>
  `${moment(start, "YYYY-MM-DD").format("DD/MM")} → ${formatDay(end)}`;

// Un pourcentage négatif ne peut pas être un arc : Chart.js dessine la valeur
// absolue, donc -22 % rendrait le même disque que +22 %. Anneau vide, chiffre
// réel conservé.
const Gauge = ({ number, text }) =>
  number >= 0 ? (
    <DoughnutChart
      className="m-auto"
      number={Math.round(number * 100) / 100}
      text={text}
    />
  ) : (
    <div
      className="m-auto"
      style={{
        width: 145,
        height: 145,
        borderRadius: "50%",
        border: "8px solid #f5f5f5",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <p style={{ color: "#db2828", fontSize: 24, margin: 0 }}>
        {getPercentageValue(number)}
      </p>
      <p style={{ color: "#db2828", fontSize: 12, margin: 0 }}>{text}</p>
    </div>
  );

export default class OverallDay extends Component {
  static contextType = AuthContext;

  render() {
    let dataCAMonth = {
      total: [],
      goal: [],
    };

    if (this.props.dataCAMonth) {
      dataCAMonth = this.props.dataCAMonth;
    }

    const dataCAMonthLenght = dataCAMonth.total.length;

    // Garde-fou : un payload en cache antérieur au déploiement peut ne pas
    // contenir yieldMonth / period (TTL Redis 300s) - évite l'écran blanc.
    const yieldMonth = this.props.data.yieldMonth || {
      yield: 0,
      closing: 0,
      mission: 0,
    };
    const period = this.props.data.period || {
      day: moment().format("YYYY-MM-DD"),
      monthStart: moment().startOf("month").format("YYYY-MM-DD"),
    };

    // La carte CA du mois vient de la série 12 mois de getData : son dernier
    // point couvre le mois de la date de fin du moteur de recherche.
    const CAMonthEnd = this.props.dateEnd || period.day;
    const CAMonthStart = moment(CAMonthEnd, "YYYY-MM-DD")
      .startOf("month")
      .format("YYYY-MM-DD");

    const CAMonthYield =
      dataCAMonth.goal[dataCAMonthLenght - 1] > 0
        ? (dataCAMonth.total[dataCAMonthLenght - 1] * 100) /
          dataCAMonth.goal[dataCAMonthLenght - 1]
        : 0;

    return (
      <Row>
        <Col xs={12} md={3} className={"mb-10 mb-20-xl"}>
          <Card
            title={`Rendement du mois - ${formatRange(
              period.monthStart,
              period.day
            )}`}
          >
            <Gauge
              number={yieldMonth.yield}
              text={`${getValue(yieldMonth.closing, 0)} / ${getValue(
                yieldMonth.mission,
                0
              )}`}
            />
          </Card>
        </Col>
        <Col xs={12} md={3} className={"mb-10 mb-20-xl"}>
          <Card title={`Rendement du jour - ${formatDay(period.day)}`}>
            <Gauge
              number={this.props.data.yield.yield}
              text={`${getValue(this.props.data.yield.closing, 0)} / ${getValue(
                this.props.data.yield.mission,
                0
              )}`}
            />
          </Card>
        </Col>
        <Col xs={12} md={3} className={"mb-10 mb-20-xl"}>
          <Card
            title={`% atteinte CA 1er du mois - ${formatRange(
              CAMonthStart,
              CAMonthEnd
            )}`}
          >
            <Gauge
              number={CAMonthYield}
              text={`${getCurrencyValue(
                dataCAMonth.total[dataCAMonthLenght - 1]
              )} / ${getCurrencyValue(
                dataCAMonth.goal[dataCAMonthLenght - 1]
              )}`}
            />
          </Card>
        </Col>
        <Col xs={12} md={3} className={"mb-10 mb-20-xl"}>
          <Card title={`% atteinte CA jour - ${formatDay(period.day)}`}>
            <Gauge
              number={this.props.data.CA.yield}
              text={`${getCurrencyValue(
                this.props.data.CA.total
              )} / ${getCurrencyValue(this.props.data.CA.goal)}`}
            />
          </Card>
        </Col>
      </Row>
    );
  }
}
